import $axios from "../../../api/accessories";
import { $api } from "../../../api/api";

export class HeaderProvide {
  static async getHeaderProductCategories() {
    try {
      const response = await $axios.get($api("get_header_categories"));
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }
  static async getHeaderServices() {
    try {
      const response = await $axios.get($api("get_header_services"));
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }
  static async getSearchProducts(searchKeyword: string) {
  try {
    const response = await $axios.get($api("get_search_product"), {
      params: { keyword: searchKeyword },
    });
    return response;
  } catch (error) {
    console.log("Axtarışda nəticə tapılmadı:", error);
    return { data: { products: [] } }; // Xəta olsa belə boş massiv qaytar
  }
}
  static async getFilterItems(id: number) {
    try {
      const response = await $axios.get($api("filter_items_id", { id }));
      return response;
    } catch (error) {
      console.log("search error", error);
      throw error;
    }
  }

  static async getFilterData(payload: number) {
    try {
      const response = await $axios.post($api("filter_data"), payload);
      return response;
    } catch (error) {
      console.log("search error", error);
      throw error;
    }
  }
  static async getLanguages() {
    try {
      const response = await $axios.get($api("get_languages"), {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("BscToken")}`,  
        },
      });
      return response;
    } catch (error) {
      console.error("API request error:", error);
      throw error;
    }
  }

}
